// extracted by mini-css-extract-plugin
export var accentColor = "#ff723d";
export var categoryBorderColor = "#036";
export var disableRipple = "false";
export var mainColor = "#036";
export var mainContrast = "#fff";
export var panelBorderColor = "#c4c8cd";
export var secondaryColor = "#06c";
export var secondaryContrast = "#fff";